/**
 * true se durante l'andata ha un servizio notte di trasferimento a pagamento
 * questo lo si verifica semplicemente controllando la presenza o meno del servizio
 * @param state
 * @returns {boolean}
 * --------------------------------------------------------------------------
 * arrivalPeriod indica il range di date di arrivo del volo di andata
 * es: utente chiede partenza 07/05
 * risposta sarà
 * 1) Period [07/05 - 07/05] se come ora volo arriva stesso giorno
 * non faccio nulla
 * 2) Period [07/05 - 08/05] se ci sono voli che arrivano stesso giorno e voli che arrivano giorno successivo
 * in preventivo non faccio nulla in itineario visualizzo il volo di arrivo il giorno dopo, l'hotel rimane al giorno stesso
 * 3) Period [08/05 - 08/05] se solo voli che arrivano giorno successivo
 * solo per il caso 3 ti passo flightTransferService con il servizio da inserire nella prima notte (pernottamento trasfer)
 * - in preventivo aggiungo il prezzo del service transfer
 * - in itinerario visualizzo il servizio transfer tra l'andata e l'arrivo
 * - nel calcolo del preventivo va aggiunto il servizio
 */
const hasArrivalServiceTransfer = function (state) {
  // arrivalPeriod: null,
  // flightTransferService: null
  return state.flightDepartureInfo.flightTransferService != null
}

const getFlightArrivalPeriod = function (state) {
  return {...state.flightDepartureInfo.arrivalPeriod}
}

const getFlightArrivalServiceTransfer = function (state) {
  return {...state.flightDepartureInfo.flightTransferService}
}

export default {
  hasArrivalServiceTransfer,
  getFlightArrivalPeriod,
  getFlightArrivalServiceTransfer
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/getters/flightDepartureInfo.js